module.exports = __webpack_public_path__ + "static/home-banner-img3-e5b37cbcb3089b89e4b9867e5dcbe028.png";